module.exports = __webpack_public_path__ + "media/images/email-subscriber-banner-pc-7e6f7f80640f8bd1f9767f0854231697.png";